<template>
    <main>
        <div id="main">
            <div class="title">
                <h2 v-html="title"></h2>
                <p class="author">
                    {{ author }}
                </p>
                <div class="button_box">
                    <button class="yinyong" @click="yinyong()">引用</button>
                    <button class="shenqing" @click="applyText()">申请全文</button>
                </div>
            </div>
            <div class="panel">
                <ul>
                    <li @click="citeScore()">
                        <p>CiteScore</p>
                        <img src="../../assets/img/youjiantou.png" alt="" />
                    </li>
                    <li @click="qikanfq()">
                        <p>期刊分区</p>
                        <img src="../../assets/img/youjiantou.png" alt="" />
                    </li>
                    <li @click="ckzy()">
                        <p>查看摘要</p>
                        <img src="../../assets/img/youjiantou.png" alt="" />
                    </li>
                    <li @click="tbl()">
                        <p>TBL</p>
                        <img src="../../assets/img/youjiantou.png" alt="" />
                    </li>
                </ul>
            </div>
            <div class="abstract">
                <div class="abstract-h3"><h3>Abstract</h3></div>
                <div class="content">
                    <div class="comoon">
                        <p class="comoon_p" v-html="abstr"></p>
                    </div>
                    <div class="comoon">
                        <p class="comoon_p" v-html="copyright"></p>
                    </div>
                    <div class="comoon">
                        <p class="comoon_p" v-html="keyword"></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="tanchaung" v-show="tanchaung">
            <div class="shenqing2">
                <div class="guanbi"><img src="../../assets/img/guanbi.png" alt="" @click="tanchaung = false" /></div>
                <div class="tc_content">我已阅读<span @click="quanwen()">申请全文须知</span>，并遵守</div>
                <div class="tc_btn">
                    <button @click="shenqing()">确定</button>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { Dialog } from "vant";

export default {
    name: "detail",
    components: {
        [Dialog.Component.name]: Dialog.Component
    },
    data() {
        return {
            title: "",
            author: "",
            abstr: "",
            keyword: "",
            copyright: "",
            pmid: "",
            tanchaung: false,
            quanwenFont: false,
            data:{}
        };
    },
    mounted() {
        this.$store.dispatch("actionsHead", { type: true, title: "", iconType: true });
        this.pmid = this.$route.query.pmid;
        this.$get("https://pm.yuntsg.com/search/get-details?pmid=" + this.pmid, "").then((res) => {
            if (res.code === 0) {
                this.data = res.data
                this.title = res.data.title;
                this.abstr = res.data.abstr;
                this.keyword = res.data.keyword;
                this.copyright = res.data.copyright;
                let Str = "";
                for (let item in res.data.author) {
                    Str += res.data.author[item].name + ";";
                }
                this.author = Str;
            } else {
                Dialog({ message: "网络错误！" });
            }
        });
    },
    methods: {
        applyText() {
            this.tanchaung = true;
        },
        quanwen() {
            this.$router.push({ path: "/quanwen" });
        },
        shenqing() {
            this.$post("https://fulltext.yuntsg.com/cases/add", [
                {
                    author: this.data.authorls,
                    doi: this.data.doi,
                    jid: this.data.jid,
                    myid: "",
                    pmid: this.data.pmid,
                    pmidNcNlmId: this.data.jid,
                    sourcecode: "pico",
                    sourcefrom: this.data.source,
                    title: this.title,
                    url: "",
                    web: 1
                }
            ]).then((res) => {
                if (res.code === 0) {
                    Dialog({ message: '申请成功！请到"我的" - "我的文档"查看' });
                    this.tanchaung = false;
                } else {
                    // Dialog({ message: res.msg });
                    this.tanchaung = false;
                }
            });
        },
        yinyong() {
            this.$router.push({ path: "/yinyong", query: { pmid: this.pmid } });
        },
        qikanfq() {
            this.$router.push({ path: "/qikan", query: { pmid: this.pmid } });
        },
        citeScore() {
            this.$router.push({ path: "/citeScore", query: { pmid: this.pmid } });
        },
        tbl() {
            this.$router.push({ path: "/tbl", query: { pmid: this.pmid } });
        },
        ckzy() {
            this.$router.push({ path: "/ckzy", query: { pmid: this.pmid } });
        }
    }
    /*  beforeRouteLeave (to, from, next) {
            // 进入C时B正常缓存 当进入的不是C时 this.$destroy()销毁后
            if (to.name === "yinyong" || to.name === "qikan "|| to.name === "citeScore"
                || to.name === "tbl" || to.name === "ckzy") {
                if (!from.meta.isKeepAlive) {
                    from.meta.isKeepAlive = true; // 当我们进入到C时开启B的缓存
                }
                next();
            } else {
                from.meta.isKeepAlive = false;
                this.$vnode.parent.componentInstance.cache = {};
                this.$vnode.parent.componentInstance.keys = [];
                next(); // 当我们前进的不是C时我们让B页面刷新
            }
        },*/
};
</script>

<style scoped>
p {
    margin: 0;
}

.tc_btn {
    width: 100%;
    height: auto;
    display: table;
}

.tc_btn button {
    width: 120px;
    height: 35px;
    margin: 0 auto;
    display: block;
    color: white;
    border-radius: 4px;
    border: none;
    background-color: #1a79af;
}

.tanchaung {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 66;
    width: 100%;
    height: 100%;
    display: block;
    background-color: rgba(0, 0, 0, 0.2);
}

.shenqing2 {
    width: 80%;
    height: 200px;
    background-color: white;
    margin: 100px auto;
    display: table;
    border-radius: 10px;
}

.shenqing3 {
    width: 80%;
    height: auto;
    padding: 15px 0;
    background-color: white;
    margin: 100px auto;
    display: table;
    border-radius: 10px;
}

.guanbi {
    width: 100%;
    height: 16px;
    margin-top: 20px;
    display: table;
}

.guanbi img {
    margin-right: 15px;
    float: right;
    height: 20px;
    width: 20px;
    display: block;
}

.tc_content {
    width: 80%;
    line-height: 40px;
    text-align: center;
    margin: 30px auto;
    display: table;
    font-size: 18px;
}

.tc_content span {
    color: #1a79ae;
}

.abstract {
    width: 100%;
    height: auto;
    margin-top: 15px;
    display: table;
}

.abstract-h3 {
    width: 100%;
}

.abstract-h3 h3,
.comoon h3 {
    font-size: 16px;
    font-weight: bold;
}

.content {
    width: 100%;
    height: auto;
    display: table;
}

.yuan {
    margin-top: 15px;
    width: 100%;
    line-height: 40px;
    height: 40px;
    display: table;
    font-size: 16px;
    color: #666666;
}

.yuan span {
    display: block;
    float: left;
    width: 6px;
    height: 6px;
    margin-right: 10px;
    margin-top: 0;
    border-radius: 3px;
    background-color: #1979ac;
}

.comoon {
    display: table;
    width: 100%;
    height: auto;
}

.comoon_p {
    margin-top: 5px;
    font-size: 16px;
    color: #1f1f1f;
    line-height: 25px;
    display: block;
}

#main {
    width: 96%;
    margin: 0 auto;
    display: table;
}

.panel {
    width: 100%;
    margin: 5px auto;
    display: table;
    border-radius: 10px;
    box-shadow: 0 0 25px #c9c9c9;
}

.panel ul {
    width: 95%;
    height: auto;
    margin: 0 auto;
    padding: 10px 0;
    display: table;
}

.panel ul li {
    margin: 20px 0 10px 5px;
    width: 95%;
    height: 20px;
    padding-left: 3%;
    border-left: 5px solid #1978ae;
}

.panel ul li p {
    float: left;
    line-height: 20px;
    display: table;
    margin: 0;
    font-size: 16px;
}

.panel ul li img {
    float: right;
    width: 23px;
    height: 23px;
    display: block;
}

.title {
    width: 100%;
    height: auto;
    display: table;
}

.title h2 {
    font-size: 20px;
    margin-top: 15px;
    font-weight: bold;
    text-align: center;
}

.author {
    font-size: 16px;
    margin-top: 10px;
    text-align: center;
    color: #999999;
}

.button_box {
    width: auto;
    display: table;
    margin: 15px auto;
}

.yinyong {
    width: 120px;
    height: 40px;
    float: left;
    font-size: 16px;
    color: white;
    border-radius: 10px;
    background-color: #1a79af;
    border: none;
}

.shenqing {
    margin-left: 20px;
    width: 120px;
    height: 40px;
    float: left;
    font-size: 16px;
    color: white;
    border-radius: 10px;
    background-color: #3ea5df;
    border: none;
}
</style>
